var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',{class:_vm.classes,attrs:{"flat":"","outlined":_vm.outlined}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }